import React from 'react';
import { useI18n } from '../../../contexts/I18nContext';
import Veo2Generator from './Veo2Generator';
import Veo2Showcase from './sections/Veo2Showcase';
import Veo2Features from './sections/Veo2Features';
import Veo2HowTo from './sections/Veo2HowTo';
import Veo2FAQ from './sections/Veo2FAQ';
import originalImage from '../../../assets/veo_original_image.jpg';
import imageGeneratedVideo from '../../../assets/video/veo_image_generate_video.mp4';
import './Veo2.scss';

const Veo2 = () => {
  const { t } = useI18n();
  return (
    <div className="veo2-page">
      <section className="veo2-hero">
        <div className="veo2-hero__glow veo2-hero__glow--left" />
        <div className="veo2-hero__glow veo2-hero__glow--right" />
        <h1 className="veo2-hero__title">{t('videoGeneration.veo.hero.title')}</h1>
        <p className="veo2-hero__subtitle">{t('videoGeneration.veo.hero.desc')}</p>
      </section>

      <Veo2Generator />

      <section className="veo2-examples">
        <div className="veo2-examples__inner">
          <h2 className="veo2-examples__title">{t('videoGeneration.veo.examples.title')}</h2>
          <p className="veo2-examples__desc">{t('videoGeneration.veo.examples.sub')}</p>
          <div className="veo2-examples__grid">
            <div className="veo2-card">
              <div className="veo2-card__header">
                <span className="veo2-card__dot" />
                {t('videoGeneration.veo.examples.originalImage')}
              </div>
              <div className="veo2-card__media veo2-card__media--image">
                <img className="veo2-card__img" src={originalImage} alt="original" />
              </div>
            </div>
            <div className="veo2-card">
              <div className="veo2-card__header">
                <span className="veo2-card__dot" />
                {t('videoGeneration.veo.examples.generatedVideo')}
                <span className="veo2-card__badge">{t('videoGeneration.veo.examples.pill')}</span>
              </div>
              <div className="veo2-card__media veo2-card__media--video">
                <video className="veo2-card__video" src={imageGeneratedVideo} controls muted playsInline preload="metadata" poster={originalImage} />
                <div className="veo2-card__video-bar"><span className="veo2-card__time">8s • 720P</span></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Veo2Showcase />
      <Veo2Features />
      <Veo2HowTo />
      <Veo2FAQ />
    </div>
  );
};

export default Veo2;